// Copy that only exists in the prototype files of the Me screens (not in shared/src/content). Each block names its
// source; lines marked "app" are new for things the prototype does not show (real settings, confirmations, tools).
import { fmtTime, QUIET_END, QUIET_START } from '@shared/rules';

export const ME = {
  // QM1_Me
  buddySub: (role: string, pron: string) => `${role} · What ${pron} remembers · Switch`,
  planSheet: 'When should we plan?',
  planSheetSub: (n: string) => `${n} messages you at this time every day.`,
  model: (usd: number) => `Model · Claude Sonnet 5.5 (fixed) · Spent so far $${usd.toFixed(2)}`,
  tools: 'TEST TOOLS · INTERNAL BUILD',
  // app
  reminders: 'Reminders',
  startAtLogin: 'Start at login', // docs/NATIVE.md tray menu
  quiet: `Quiet hours: no reminders from ${fmtTime(QUIET_START)} to ${fmtTime(QUIET_END)}.`,
  addPoints: 'Add points',
  deleteTitle: 'Delete your account?',
  deleteBody: "This deletes your account, your chats and your progress with every buddy. It can't be undone.",
  restartTitle: 'Restart onboarding?',
  restartBody: 'This deletes this test account so you can go through onboarding again with the same invite.',
  forgetTitle: (n: string) => `Forget everything ${n} remembers?`,
  forgetBody: "The whole list goes. You can't undo this.",
  // QM2_Buddy
  closeNote: "This grows on its own as you spend days together, and it follows how you two talk. There's no setting for it.",
  memSub: (n: string) => `Change or delete anything. ${n} only uses what's here.`,
  memEmpty: 'Nothing here yet.', // app
  forgotten: 'Forgotten.',
  forgottenAll: (n: string) => `Forgotten. ${n} starts fresh.`,
  aiChar: (n: string) => `${n} is an AI character, not a therapist or a doctor.`,
  relationship: { buddy: 'Buddy', romance: 'Romantic' }, // app (ARCHITECTURE §5: set only in chat, after the user asks)
  romanceNote: 'You asked for this in chat. Saying "Let\'s just be friends" switches back.', // app
  // QM3_Switch
  comes: (streak: string) => ['Your plan and cards', `Your streak (${streak})`, 'Your level and points'],
  stays: (n: string, obj: string) => `Your story with ${obj}, keepsakes, and how close you are. ${n} will be here if you come back.`,
  switchBody: (n: string) => `${n} will plan tomorrow with you. Your plan, streak and level come along.`,
  // QM4_Core
  price: '$9.99 a month · test price',
  perks: (n: string) => [
    { icon: 'chat', title: 'Talk as much as you want', sub: '' },
    { icon: 'monitor', title: `${n} on your desktop all day`, sub: 'Pinned in a corner while you work' },
    { icon: 'calendar', title: 'Monthly look-back', sub: `What changed this month, in ${n}'s words` },
    { icon: 'photo', title: 'Extra story moments', sub: 'Moments outside the work' },
    { icon: 'headphones', title: 'Voice', sub: 'Coming later', muted: true },
  ] as const,
  simulated: 'Simulated purchase for the internal build. No payment is taken.',
  vipOn: "You're on VIP (simulated).",
  charged: 'Nothing was charged.',
  vipOff: 'Turn off VIP', // app
  // QM5_Friends
  demo: 'Demo · pretend friends',
  togetherNote: 'A day counts when you both finish a card. Nobody sees what your cards say.',
  status: { done: 'You both finished a card today', 'not-yet': (n: string) => `${n} hasn't done a card yet today`, new: 'Joined Thursday' },
  sentWave: (n: string) => `Sent. ${n} will see a little wave.`,
  clubTally: 'You 5 · Jess 4 · Dev 3',
  shared: 'Shared with your friends (demo).', // app
};
